<ng-template #registrationDoneModal let-modal>
  <div class="modal-body">
    <div class="regs-icon-wrap">
      <img src="./assets/images/ic-registered.svg" alt="Icon">
    </div>
    <h4 class="modal-title" id="modal-basic-title">Registered Successfully</h4>
    <h5 *ngIf="registrationApprovalRequired" class="modal-info-text light">
      You are registered successfully with us and your registration is currently under review. Once approved, you’ll receive a confirmation email with details on how to log in and start exploring!
    </h5>
    <h5 *ngIf="!registrationApprovalRequired" class="modal-info-text light">
      Your account has been created successfully and is ready to use.
    </h5>
    <div class="btn-grps">
      <!--<app-button [btnCss]="'btn btn-primary w-100 btn-lg'" [btnText]="'Register Business'" [btnTitle]="'Register Business'" [routerLink]="['/onboarding']" [routerLinkActive]="'router-link-active'" (onBtnClick)="modal.close('Close click');"></app-button>-->
      <app-button [btnCss]="'btn btn-text w-100 btn-lg btn-md'" [btnText]="'Close'" [btnTitle]="'Close'" (onBtnClick)="modal.close('Close click')"></app-button>
    </div>
  </div>
</ng-template>
